import axios from '../../Axios/Default';
// axios.defaults.baseURL = process.env.REACT_APP_URL_HUAWEI;
const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const CheckPLTS = (payload) => {
  const promise = axios.post("/admin/set-station/check", payload, config);
  return promise;
};


export const CreatePLTS = (payload) => {
  const promise = axios.post("/admin/set-station/add", payload, config);
  return promise;
};


export const UpdatePLTS = (payload,id) => {
  const promise = axios.put("/admin/set-station/edit/"+id, payload, config);
  return promise;
};


export const getListPLTS = (page, perpage, search) => {
  
  const promise = axios.get("/admin/set-station/get-all?page="+page+"&perpage="+perpage, [], config);
  return promise;
};